export default __webpack_public_path__ + "static/media/product_02.522f9028.jpg";